import { Box, Flex, styled } from '@grupoboticario/flora-react';

export const styles = {
  OptIn: styled(Box, {
    background: '$backgroundPrimary',
    position: 'sticky',
    bottom: '0',
    padding: '$2 0',

    '@tablet': {
      position: 'initial',
    },
  }),

  OptInButtonWrapper: styled(Flex, {
    gap: '$4',
    flexDirection: 'column-reverse',

    '@tablet': {
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
  }),
};

export default styles;
